var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSensorAlert = function SvgSensorAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    fill: "#E66B45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFC",
    d: "m13 22 8.485 8.485L29.971 22l-8.486-8.485z"
  })));
};
export { SvgSensorAlert as ReactComponent };
export default "data:image/svg+xml,%3csvg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='22' cy='22' r='18' fill='%23E66B45' /%3e %3crect width='12' height='12' transform='matrix(0.707107 0.707107 0.707107 -0.707107 13 22)' fill='%23F9FAFC'/%3e %3c/svg%3e";